import React, {useState, useEffect} from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Card,
    CardActionArea,
    CardContent,
    Avatar,
    Stack,
    Typography,
    CircularProgress
} from "@mui/material";

import {useDispatch, useSelector} from "react-redux";
import {usersActions} from "../../../../modules/users/users.actions.js";
import OperateurPickerList from "./OperateurPickerList";

const OperateurPicker = ({label, selected, onChange, allowNone = false, required = false}) => {
    const dispatch = useDispatch();
    const operateurs = useSelector((state) => state.users?.operateurs);
    const loading = useSelector((state) => state.users?.loading);

    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (!operateurs) {
            dispatch(usersActions.fetchOperateurs());
        }
    }, [operateurs, dispatch]);

    const selectedOperateur = operateurs?.find((o) => o?.id === selected);

    return (
        <Stack spacing={2} justifyContent="center">
            <Typography variant="body2" sx={{mb: 1}} textAlign="center" gutterBottom>
                {label.toUpperCase()} {required && <span style={{color: "red"}}>*</span>}
            </Typography>

            <Card variant="outlined">
                <CardActionArea onClick={() => setOpen(true)}>
                    <CardContent>
                        {loading &&
                            <Stack direction="column" spacing={2} justifyContent="center" alignItems={"center"}>
                                <CircularProgress/>
                                <Typography variant={"subtitle2"} textAlign={"center"}>
                                    Chargement des données...
                                </Typography>
                            </Stack>

                        }
                        {!loading &&
                            <>
                                {selectedOperateur ? (
                                    <Stack direction="row" spacing={2} alignItems="center">
                                        <Avatar>{selectedOperateur.libelle?.charAt(0) ?? "?"}</Avatar>
                                        <Typography>{selectedOperateur.libelle}</Typography>
                                    </Stack>
                                ) : (
                                    <Typography color="text.secondary">
                                        Aucun opérateur sélectionné
                                    </Typography>
                                )
                                }
                            </>
                        }

                    </CardContent>
                </CardActionArea>
            </Card>

            <Dialog fullWidth maxWidth="xs" open={open} onClose={() => setOpen(false)}>
                <DialogTitle>{label}</DialogTitle>
                <DialogContent>
                    {loading ? (
                        <CircularProgress/>
                    ) : (
                        <OperateurPickerList
                            operateurs={operateurs}
                            selected={selected}
                            onChange={(val) => {
                                onChange(val);
                                setOpen(false);
                            }}
                            allowNone={allowNone}
                        />
                    )}
                </DialogContent>
            </Dialog>
        </Stack>
    );
};

export default OperateurPicker;
